"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesFloatingInput = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "placeholder", type: "string", description: "A placeholder to the input." }),
    React.createElement(common_1.Property, { name: "leftElement", type: "element", description: "A React element in the left side, before input." }))); };
exports.PropertiesFloatingInput.displayName = 'PropertiesFloatingInput';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFloatingInputPage/PropertiesFloatingInput.tsx
// module id = 676
// module chunks = 0